"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _Collapsible = _interopRequireDefault(require("../../../Collapsible"));
var _Icon = _interopRequireWildcard(require("../../../Icon"));
var _context = require("../context");
var Style = _interopRequireWildcard(require("./style"));
var Types = _interopRequireWildcard(require("./types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var TableRow = /*#__PURE__*/(0, _react.forwardRef)(function (_a, _ref) {
  var children = _a.children,
    hiddenElement = _a.hiddenElement,
    onHover = _a.onHover,
    onClick = _a.onClick,
    onMouseEnter = _a.onMouseEnter,
    onMouseLeave = _a.onMouseLeave,
    rest = __rest(_a, ["children", "hiddenElement", "onHover", "onClick", "onMouseEnter", "onMouseLeave"]);
  var _b = (0, _react.useState)(),
    isHover = _b[0],
    setIsHover = _b[1];
  var _c = (0, _react.useState)(),
    isOpen = _c[0],
    setIsOpen = _c[1];
  var _d = (0, _react.useState)(0),
    totalCells = _d[0],
    setTotalCells = _d[1];
  var _e = (0, _context.useTableContext)(),
    type = _e.type,
    state = _e.state;
  var elementType = "tr";
  var context = (0, _react.useMemo)(function () {
    return {
      type: elementType,
      state: state,
      parentType: type,
      parentState: state
    };
  }, [elementType, type, state]);
  var collapsible = state.collapsible;
  var findRowType = [!collapsible && type === "thead" && Types.TableRowEnum.THead, collapsible && type === "thead" && Types.TableRowEnum.THeadCollapsible, (!collapsible || collapsible && !hiddenElement && type === "tbody") && Types.TableRowEnum.TBody, collapsible && type === "tbody" && /*#__PURE__*/(0, _react.isValidElement)(hiddenElement) && Types.TableRowEnum.TBodyCollapsible].find(Boolean);
  (0, _react.useEffect)(function () {
    if (onHover && isHover !== undefined) {
      onHover(isHover);
    }
  }, [onHover, isHover]);
  var handleOnMouseEnter = (0, _react.useCallback)(function (event) {
    setIsHover(true);
    if (onMouseEnter) {
      onMouseEnter(event);
    }
  }, [onMouseEnter]);
  var handleOnMouseLeave = (0, _react.useCallback)(function (event) {
    setIsHover(false);
    if (onMouseLeave) {
      onMouseLeave(event);
    }
  }, [onMouseLeave]);
  var handleCollapsibleRowOnClick = (0, _react.useCallback)(function (event) {
    setIsOpen(!isOpen);
    if (onClick) {
      onClick(event);
    }
  }, [isOpen, onClick]);
  var defaultProps = {
    onClick: onClick,
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave
  };
  switch (findRowType) {
    case Types.TableRowEnum.TBody:
      {
        return (0, _jsxRuntime.jsx)(_context.TableContext.Provider, __assign({
          value: context
        }, {
          children: (0, _jsxRuntime.jsx)(Style.Row, __assign({}, rest, defaultProps, {
            ref: _ref
          }, {
            children: children
          }))
        }));
      }
    case Types.TableRowEnum.THead:
      {
        return (0, _jsxRuntime.jsx)(_context.TableContext.Provider, __assign({
          value: context
        }, {
          children: (0, _jsxRuntime.jsx)(Style.THeadRow, __assign({}, rest, defaultProps, {
            ref: _ref
          }, {
            children: children
          }))
        }));
      }
    case Types.TableRowEnum.THeadCollapsible:
      {
        return (0, _jsxRuntime.jsx)(_context.TableContext.Provider, __assign({
          value: context
        }, {
          children: (0, _jsxRuntime.jsxs)(Style.THeadRow, __assign({}, rest, defaultProps, {
            ref: _ref
          }, {
            children: [children, (0, _jsxRuntime.jsx)(Style.CollapsibleEmptyCell, {})]
          }))
        }));
      }
    case Types.TableRowEnum.TBodyCollapsible:
      {
        return (0, _jsxRuntime.jsxs)(_context.TableContext.Provider, __assign({
          value: context
        }, {
          children: [(0, _jsxRuntime.jsxs)(Style.CollapsibleRow, __assign({}, rest, defaultProps, {
            ref: function ref(element) {
              if (element) {
                setTotalCells(element.cells.length);
                if (_ref) {
                  _ref.current = element;
                }
              }
            },
            "$active": isOpen,
            onClick: handleCollapsibleRowOnClick
          }, {
            children: [children, (0, _jsxRuntime.jsx)(Style.CollapsibleIconCell, {
              children: (0, _jsxRuntime.jsx)(_Icon.default, {
                size: "tiny",
                color: isOpen ? "white" : undefined,
                icon: isOpen ? _Icon.Icons.ChevronUp : _Icon.Icons.ChevronDown
              })
            })]
          })), (0, _jsxRuntime.jsx)(Style.CollapsibleRowWrapper, {
            children: (0, _jsxRuntime.jsx)(Style.CollapsibleCell, __assign({
              colSpan: totalCells
            }, {
              children: (0, _jsxRuntime.jsx)(_Collapsible.default, __assign({
                open: isOpen
              }, {
                children: hiddenElement
              }))
            }))
          })]
        }));
      }
    default:
      {
        return null;
      }
  }
});
var _default = TableRow;
exports.default = _default;